import Paper, { PaperProps } from '@mui/material/Paper'
import Draggable from 'react-draggable'
import React, { ReactElement } from 'react'

const PaperComponent = (props: PaperProps): ReactElement => {
    const nodeRef = React.useRef<HTMLDivElement>(null)

    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    )
}

export default PaperComponent
